import React, { useRef, useState } from "react";
import { ArrowsHorizontalIcon } from "@phosphor-icons/react";

export const BeforeAfterSlider = ({ before, after }) => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const el = containerRef.current;
    if (!el || clientX == null) return;
    const rect = el.getBoundingClientRect();
    const p = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    setPos(p);
  };

  const start = (clientX) => { dragging.current = true; move(clientX); };
  const onMouseMove = (e) => { if (dragging.current) move(e.clientX); };
  const stop = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full aspect-[4/3] overflow-hidden rounded-sm border border-slate-200 select-none cursor-ew-resize bg-slate-100"
      onMouseDown={(e) => start(e.clientX)}
      onMouseMove={onMouseMove}
      onMouseUp={stop}
      onMouseLeave={stop}
      onTouchStart={(e) => start(e.touches[0]?.clientX)}
      onTouchMove={(e) => move(e.touches[0]?.clientX)}
      onTouchEnd={stop}
    >
      {/* After (full) */}
      <img src={after} alt="after" draggable={false} className="absolute inset-0 w-full h-full object-cover pointer-events-none" />
      <span className="absolute top-2 right-2 bg-green-600 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-sm pointer-events-none">After</span>

      {/* Before (clipped to pos%) */}
      <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt="before" draggable={false} className="absolute inset-0 w-full h-full object-cover" />
        <span className="absolute top-2 left-2 bg-navy-900 text-white text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-sm">Before</span>
      </div>

      {/* Divider + handle */}
      <div className="absolute top-0 bottom-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-0 bottom-0 w-0.5 bg-white -translate-x-1/2 shadow-[0_0_6px_rgba(0,0,0,0.4)]" />
        <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white shadow-lg flex items-center justify-center">
          <ArrowsHorizontalIcon size={18} weight="bold" className="text-navy-900" />
        </div>
      </div>
    </div>
  );
};
